var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3346 17.1667V13.8333C28.3346 9.23096 24.6037 5.5 20.0013 5.5C15.3989 5.5 11.668 9.23096 11.668 13.8333V17.1667M20.0013 24.6667V28M14.668 35.5H25.3346C28.1349 35.5 29.535 35.5 30.6046 34.955C31.5454 34.4757 32.3103 33.7108 32.7897 32.7699C33.3346 31.7004 33.3346 30.3003 33.3346 27.5V25.1667C33.3346 22.3664 33.3346 20.9663 32.7897 19.8967C32.3103 18.9559 31.5454 18.191 30.6046 17.7116C29.535 17.1667 28.1349 17.1667 25.3346 17.1667H14.668C11.8677 17.1667 10.4676 17.1667 9.39802 17.7116C8.45721 18.191 7.6923 18.9559 7.21294 19.8967C6.66797 20.9663 6.66797 22.3664 6.66797 25.1667V27.5C6.66797 30.3003 6.66797 31.7004 7.21294 32.7699C7.6923 33.7108 8.45721 34.4757 9.39802 34.955C10.4676 35.5 11.8677 35.5 14.668 35.5Z",
    stroke: "url(#paint0_linear_2763_27425)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2763_27425",
    x1: 6.66797,
    y1: 5.5,
    x2: 34.1764,
    y2: 6.29281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B135CC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock01);
export default __webpack_public_path__ + "static/media/lock01.338d15037476eef7263a8051c05ad39d.svg";
export { ForwardRef as ReactComponent };